// extracted by mini-css-extract-plugin
export var mainHeader = "typography-module--main-header--1NrtB";
export var mainHeaderDark = "typography-module--main-header-dark--1K0iS";
export var secondaryHeader = "typography-module--secondary-header--1Z1Ya";
export var secondaryHeaderDark = "typography-module--secondary-header-dark--w1Fvy";
export var simpleHeaderDark = "typography-module--simple-header-dark--3fOF1";
export var mainDescription = "typography-module--main-description--3jbAO";
export var mainDescriptionDark = "typography-module--main-description-dark--yjvWS";